import { DateFromTo } from './vnext.models';

export interface BurnDataVNext {
    burner?: Burner;
    idExaminations: string[];
    clientName: string;
    mediaType: string;
}

export interface Burner {
    description: string | null;
    ipAddress: string | null;
}

export interface MPSResultMpsDTO {
    accepted: boolean | null;
    message: string | null;
    alertMsg: string | null;
    jobIDs: number[] | null;
    mediaType: string | null;
    nMediaInRequest: number | null;
}

export interface MpsJobManagementResult {
    jobId: number;
    result: boolean;
}

export interface MpsJobManagementOptions {
    jobIds: number[];
    failureReason: number | null;
    managementType: MpsJobManagementType;
}

export enum MpsJobManagementType {
    Copy = 0,
    Delete = 1,
    Unblock = 2,
}

export interface WorklistMpsSearchingParams {
    patientName: string | null;
    status: string | null;
    exam: string | null;
    executionDate: DateFromTo | null;
    server: string | null;
    burner: string | null;
}

export interface Queue {
    businessUnit_Description: string | null;
    businessUnit_ID?: string;
    check: number;
    clientDescription: string | null;
    clientID?: number;
    clientIP: string | null;
    copies?: number;
    eND_Time: Date;
    external_ID: string;
    failed: number;
    failureDescription: string | null;
    failureReason: string | null;
    groupID: number;
    hasContent: boolean;
    hostname: string | null;
    enD_Time?: Date;
    iN_Burner_Time?: Date;
    iN_Creating_Time?: Date;
    iN_Pending_Time?: Date;
    iN_Time: Date;
    jobDescription: string | null;
    jobID: number;
    jobPriority?: number;
    mPSDescription: string | null;
    mediaGroupOrdinalNumber?: number;
    mediaGroupTotalNumber?: number;
    mediaGroupUID?: string;
    mediaType: string | null;
    modalities: string | null;
    multi?: number;
    multiCD: string | null;
    patientBirthDate?: Date;
    patientName: string | null;
    patientSex: string | null;
    queueOrder: number;
    robotDescription: string | null;
    robot_GUID?: string;
    server_GUID?: string;
    status: number;
    statusDetails: string | null;
    studies: string | null;
    tags: string | null;
    useBUCover?: boolean;
    validateTime: string | null;
    writePermission: boolean;
}
